import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTruckModel } from '@/features/truck-models/api'

import { truckModelParamsSchema } from '../-modals'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/truck-models/$truckModelId'
)({
  parseParams: (params) => parse(truckModelParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, truckModelId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      truckModel: await fetchTruckModel(
        {
          tenantKey,
          truckModelId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.truckModel.name
    }
  ]
})
